export default {
  open(state) {
    state.open = true
  },
  close(state) {
    state.open = false
  },
  toggle(state) {
    state.open = !state.open
  },
  setManualDocked(state, value) {
    state.manualDocked = value
  },
  setConversationId(state, conversationId) {
    state.conversationId = conversationId
  },
  addMessage(state, message) {
    state.messages.push(message)
  },
  appendToMessage(state, { id, delta }) {
    const message = state.messages.find((message) => message.id === id)
    if (message) {
      message.content += delta
    }
  },
  setSending(state, value) {
    state.isSending = value
  },
  addToolCall(state, { id, name }) {
    state.messages.push({ id, role: 'tool', name, status: 'running' })
  },
  addWidget(state, { id, widgetType, data }) {
    state.messages.push({ id, role: 'widget', widgetType, data })
  },
  completeToolCall(state, id) {
    const toolMessage = state.messages.find(
      (message) => message.role === 'tool' && message.id === id
    )
    if (toolMessage) {
      toolMessage.status = 'done'
    }
  },
  settleRunningToolCalls(state) {
    state.messages
      .filter(
        (message) => message.role === 'tool' && message.status === 'running'
      )
      .forEach((message) => {
        message.status = 'done'
      })
  },
  setQuota(state, quota) {
    state.quota = quota
  },
  setSuggestedActions(state, { resource, actions }) {
    state.suggestedActionsResource = resource
    state.suggestedActions = actions ?? []
  },
  clearSuggestedActions(state) {
    state.suggestedActionsResource = null
    state.suggestedActions = []
    state.requestedSuggestedAction = null
  },
  requestSuggestedAction(state, request) {
    state.requestedSuggestedAction = request
  },
  clearRequestedSuggestedAction(state) {
    state.requestedSuggestedAction = null
  },
  setDockedWidth(state, width) {
    state.dockedWidth = Math.min(Math.max(width, 320), 720)
  },
  setMessages(state, messages) {
    state.messages = messages
  },
  // status: pending, then approved or rejected by the user, or skipped when the
  // conversation moved on without a decision.
  // Replaces the call's tool row (same id): the change has not run.
  addApproval(state, { id, tool, summary }) {
    const approval = {
      id,
      role: 'approval',
      tool,
      summary,
      status: 'pending',
      submitted: false
    }
    const index = state.messages.findIndex(
      (message) => message.role === 'tool' && message.id === id
    )
    if (index === -1) {
      state.messages.push(approval)
    } else {
      state.messages.splice(index, 1, approval)
    }
  },
  setApprovalStatus(state, { id, status }) {
    const approval = state.messages.find(
      (message) => message.role === 'approval' && message.id === id
    )
    if (approval) {
      approval.status = status
    }
  },
  markApprovalsSubmitted(state, ids) {
    state.messages
      .filter(
        (message) => message.role === 'approval' && ids.includes(message.id)
      )
      .forEach((message) => {
        message.submitted = true
      })
  },
  skipPendingApprovals(state) {
    state.messages
      .filter((message) => message.role === 'approval' && !message.submitted)
      .forEach((message) => {
        message.status = 'skipped'
        message.submitted = true
      })
  },
  restoreApprovals(state, { ids, pendingIds }) {
    state.messages
      .filter(
        (message) => message.role === 'approval' && ids.includes(message.id)
      )
      .forEach((message) => {
        const isPending = pendingIds.includes(message.id)
        message.status = isPending ? 'pending' : 'skipped'
        message.submitted = !isPending
      })
  }
}
